import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import he from "./locales/he.json";
import ar from "./locales/ar.json";
import en from "./locales/en.json";

export const SUPPORTED_LANGS = ["he", "ar", "en"] as const;
export type Lang = typeof SUPPORTED_LANGS[number];

export const LANG_META: Record<Lang, { label: string; nativeLabel: string; dir: "rtl" | "ltr"; htmlLang: string; ogLocale: string }> = {
  he: { label: "עברית", nativeLabel: "עב", dir: "rtl", htmlLang: "he", ogLocale: "he_IL" },
  ar: { label: "العربية", nativeLabel: "ع", dir: "rtl", htmlLang: "ar", ogLocale: "ar_IL" },
  en: { label: "English", nativeLabel: "EN", dir: "ltr", htmlLang: "en", ogLocale: "en_US" },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      he: { translation: he },
      ar: { translation: ar },
      en: { translation: en },
    },
    fallbackLng: "he",
    supportedLngs: SUPPORTED_LANGS,
    interpolation: { escapeValue: false },
    detection: {
      order: ["path", "localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      lookupFromPathIndex: 0,
      caches: ["localStorage"],
    },
  });

export const applyLangToHtml = (lang: Lang) => {
  const meta = LANG_META[lang];
  document.documentElement.lang = meta.htmlLang;
  document.documentElement.dir = meta.dir;
};

export default i18n;
